import clsx from "clsx";
import "./AddNewModalContent.scss";
import { ReactNode } from "react";

type AddNewModalContentProps = {
  overrideClassNames?: string;
  children?: ReactNode;
};

export const AddNewModalContent = ({
  overrideClassNames,
  children,
}: AddNewModalContentProps) => {
  return (
    <div
      className={clsx(
        "ui-add-new-modal-body ui-modal-content-scrollable",
        overrideClassNames,
      )}
    >
      {children}
    </div>
  );
};
